import type { ResetPasswordApiCreationQuery } from "@/Modules/Models/Api/Auth";
import type { ResetPasswordCreationQuery } from "@/Modules/Models/Domain/Auth";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { resetPassword } from "@/Services/TherapyApi/Auth";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import useAuthStore from "@/Modules/Auth/Store";

async function resetPasswordAH(resetPasswordCreationQuery: ResetPasswordCreationQuery): Promise<void> {
  const authStore = useAuthStore();
  const resetPasswordApiCreationQuery: ResetPasswordApiCreationQuery = {
    hash: resetPasswordCreationQuery.hash,
    new_password: resetPasswordCreationQuery.newPassword,
  };

  try {
    await resetPassword(resetPasswordApiCreationQuery);

    authStore.notification = {
      type: NotificationType.SUCCESS,
      code: null,
      message: "account.password.your_password_has_been_changed",
    };
  } catch (error: unknown) {
    const code = isApiError(error) ? error["error_code"] : null;

    authStore.notification = {
      type: NotificationType.ERROR,
      code: code,
      message: "login.error.the_data_is_incorrect",
    };
  } finally {
    authStore.isLoading = false;
  }
}

export default resetPasswordAH;
